import api from '@/helpers/api'

const API_READ=`/api/public/`

export default {
  namespaced:true,
  state: {
    status: '',
    publics:[],
    currUser: {},
    errMessage: ''
  },
  mutations: {
    request(state){
        state.status = 'loading'
    },
    success(state){
        state.status = 'success'
    },
    error(state){
        state.status = 'error'
    },
    get_booking_engine_api_success(state, {publics}){
        state.public = publics
    },
  },
  actions: {
    get_booking_engine_api({commit}){

        commit('request');

        return new Promise((resovle, reject) => {
            api.request('get', `${API_READ}get_booking_engine_host`)
            .then((result) => {         
                commit('success')
                return resovle(result.data.data);
            }).catch((err) => {
                commit('error', {message: err});
                return reject(err)
            });
        });
    }
  },
  getters : {
    publics: ()=>state => state.publics,
  }
}
